const API_PREFIX = '/api';

export const withApiPrefix = (baseUrl?: string) => {
  const normalizedBaseUrl = (baseUrl || 'http://localhost:3000').replace(/\/+$/, '');

  return normalizedBaseUrl.endsWith(API_PREFIX)
    ? normalizedBaseUrl
    : `${normalizedBaseUrl}${API_PREFIX}`;
};
